import { Divider } from '@mui/material';
import React from 'react';

import { ITaskInfo } from '@/entities/task/model/client';
import { LoadingStageModel } from '@/models/LoadingStageModel';

import { TaskDescription } from '../TaskDescription';

import s from './TaskDescriptionSection.module.scss';

type TaskDescriptionSectionProps = {
  task: ITaskInfo | null;
  loadingStage: LoadingStageModel;
};

export const TaskDescriptionSection: React.FC<TaskDescriptionSectionProps> = ({
  task,
  loadingStage,
}) => {
  if (loadingStage.isError) {
    return (
      <>
        <Divider />
        <div className={s.error}>Не удалось загрузить описание задачи</div>
      </>
    );
  }

  if (!task || !task.description) {
    return null;
  }

  return (
    <>
      <Divider />
      <TaskDescription description={task.description} />
    </>
  );
};
